import { Component, Input, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { InputFieldType } from '../../models/input-types.enum';
import {
  TestEmailPayload,
  TestEmailService,
} from '../../../core/services/api/test-email.service';
import { NotificationsService } from 'angular2-notifications';
import { ErrorHandlingService } from '../../../core/services/error-handling.service';
import { untilDestroyed } from '@ngneat/until-destroy';
import { take } from 'rxjs';
import { ProductLetterType } from '../../models/product-letter.interface';

@Component({
  selector: 'app-send-email-sample',
  templateUrl: './send-email-sample.component.html',
  styleUrls: ['./send-email-sample.component.scss'],
})
export class SendEmailSampleComponent implements OnInit {
  @Input() content?: string;
  @Input() productId?: number;
  @Input() type!: ProductLetterType;

  form!: FormGroup;

  constructor(
    private testEmailService: TestEmailService,
    private notificationService: NotificationsService,
    private errHandle: ErrorHandlingService,
  ) {}

  ngOnInit(): void {
    this.form = new FormGroup({
      email: new FormControl('', [Validators.email, Validators.required]),
    });
  }

  protected readonly InputFieldType = InputFieldType;

  onSendEmailClick() {
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      this.form.updateValueAndValidity();
      return;
    }
    if (!this.content) {
      this.notificationService.warn('Please, provide email content');
      return;
    }
    const payload: TestEmailPayload = {
      email: this.form?.value?.email,
      content: this.content + '',
      product_id: this.productId + '',
      letter_type: this.type,
    };

    this.testEmailService
      .send(payload)
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.notificationService.success('Email is successfully sent.');
        },
        error: (err) => {
          this.errHandle.errorHandling(err);
        },
      });
  }
}
